import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useTranslation } from '../../context/LanguageContext';
import { HUMPRO_APP_DOWNLOAD_URL } from '../../config/externalLinks';
import logo from '../../assets/logo.jpg';
import { heroStagger, heroItem, transitionSnappy } from '../../motion/presets';
import './upcoming.scss';

const Upcoming = () => {
  const { content } = useTranslation();
  const u = content.upcoming;

  return (
    <motion.main
      className="upcoming-page"
      initial="hidden"
      animate="visible"
      variants={heroStagger}
    >
      <div className="bg-orb orb-one" />
      <div className="bg-orb orb-two" />
      <div className="bg-orb orb-three" />

      <motion.section className="upcoming-card" variants={heroItem}>
        <motion.div className="logo-wrap" variants={heroItem}>
          <img src={logo} alt="HumPro logo" className="upcoming-logo" />
        </motion.div>

        <motion.p className="status-pill" variants={heroItem}>
          {u.status}
        </motion.p>
        <motion.h1 variants={heroItem}>{u.title}</motion.h1>
        <motion.p className="subtitle" variants={heroItem}>
          {u.subtitle}
        </motion.p>

        <motion.a
          className="playstore-btn"
          href={HUMPRO_APP_DOWNLOAD_URL}
          target="_blank"
          rel="noreferrer"
          aria-label={u.playAria}
          variants={heroItem}
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          transition={transitionSnappy}
        >
          <span className="play-icon" aria-hidden="true" />
          <span className="playstore-text">
            <small>{u.playSmall}</small>
            <strong>{u.playStrong}</strong>
          </span>
        </motion.a>

        <motion.p className="upcoming-back" variants={heroItem}>
          <Link to="/">{u.back}</Link>
        </motion.p>
      </motion.section>
    </motion.main>
  );
};

export default Upcoming;
